import { render, staticRenderFns } from "./khe.vue?vue&type=template&id=5d2059c1&"
import script from "./khe.vue?vue&type=script&lang=js&"
export * from "./khe.vue?vue&type=script&lang=js&"
import style0 from "./khe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports